import { motion } from "framer-motion";
import Pricing from "../components/Pricing";
import { useLanguage } from "../context/LanguageContext";

export default function PricingPage() {
  const { t, dir, lang } = useLanguage();
  const pp = t.pricingPage;
  return (
    <>
      <section
        dir={dir}
        lang={lang}
        className="relative pt-40 pb-10 px-5 sm:px-8"
        data-testid="pricing-page-hero"
      >
        <div className="mx-auto max-w-7xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-agency-gold flex items-center gap-3">
            <span className="h-px w-8 bg-agency-gold" /> {pp.eyebrow}
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="mt-6 font-display text-5xl md:text-7xl font-black tracking-[-0.03em] max-w-4xl"
          >
            {pp.heading1} <span className="gradient-gold-text">{pp.headingGold}</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 max-w-2xl text-white/60 text-base md:text-lg"
          >
            {pp.sub}
          </motion.p>
        </div>
      </section>
      <Pricing />
    </>
  );
}
